import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBranding } from "../context/BrandingContext";
import axios from "axios";
import { API_URL, getCookie, getHeaders } from "../helper/commonApi";
import Loader from "../components/loader";

const DashboardComponent = () => {
  const navigate = useNavigate();

  const { colors } = useBranding();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  // const testId = data?.free_test?.assigned_test_id
  // localStorage.setItem('_GRE_test_id_for_result', testId)

  // const testId = data?.paid_tests?.length > 0
  //   ? data.paid_tests[0]?.assigned_test_id
  //   : data?.free_test?.assigned_test_id;

  // if (testId) {
  //   localStorage.setItem('_GRE_test_id_for_result', testId);
  // }

  //  test id login for free test and paid test
  // let testId;

  // if (data?.paid_tests?.length > 0) {
  //   const firstPaidTest = data.paid_tests[0];
  //   if (firstPaidTest?.status === "completed") {
  //     testId = firstPaidTest.assigned_test_id;
  //   } else {
  //     testId = data?.free_test?.assigned_test_id;
  //   }
  // } else {
  //   testId = data?.free_test?.assigned_test_id;
  // }

  // Check if there are paid tests
  // if (data?.paid_tests?.length > 0) {
  //   // Filter only completed paid tests
  //   const completedPaidTests = data.paid_tests.filter(
  //     (test) => test.status === "completed"
  //   );

  //   if (completedPaidTests.length > 0) {
  //     // Get the last completed test
  //     testId = completedPaidTests[completedPaidTests.length - 1].assigned_test_id;
  //   } else {
  //     // If no completed paid test, fallback to free test
  //     testId = data?.free_test?.assigned_test_id;
  //   }
  // } else {
  //   // If no paid tests, use free test
  //   testId = data?.free_test?.assigned_test_id;
  // }

  // if (testId) {
  //   localStorage.setItem('_GRE_test_id_for_result', testId);
  //   // console.log("Stored GRE testId:", testId);
  // }

  // const fullName = localStorage.getItem('_register_GRE_LOGIN_full_name');

  const userId = localStorage.getItem('_register_GRE_LOGIN_userId');

  useEffect(() => {
    const jwtToken = getCookie('_GRE_JWT_TOKEN');

    if (!userId || !jwtToken) {
      localStorage.clear();
      document.cookie = "_GRE_JWT_TOKEN=; max-age=0; path=/;";
      navigate('/')
      return;
    }

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getData = async () => {
    const payload = {
      user_id: userId,
      subject_id: 1
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/dashboard`, payload, {
        headers: getHeaders()
      });

      if (res.status === 200) {
        // console.log(res?.data)

        // if (!res?.data?.status) {
        //   console.log("status....")
        // }
        if (res?.data?.message === "Unauthorized. Invalid API Key or JWT Token.") {
          localStorage.clear();
          navigate('/')
        }
        setData(res.data.data);
        setLoading(false);
      } else {
        console.error("Failed to fetch dashboard");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error fetching dashboard:", err);
      setLoading(false);
    }
  }

  return (
    <div>
      {loading ? <Loader /> :
        <div style={{ margin: "20px" }} >
          <div className="container main-border bg-white ">
            <div className="dashboard">
              {/* <h1 style={{ color: colors?.primaryColor }}>Hy <span style={{ textTransform: "capitalize" }}>{fullName}</span>,</h1> */}
              <h2>Dashboard</h2>
              {/* <p className="subtitle">
                Start your GRE prep journey with our free mock test.
              </p> */}
              <div className="cards">
                <div className="card">
                  <h3>Free Test <span style={{ color: "#525252", fontSize: '14px', marginLeft: "8px" }}>({data?.free_test ? (data?.free_test?.status === "completed" ? "0" : "1 Free") : "0"} Test Available)</span></h3>

                  {data?.free_test ?
                    <div>
                      <p>Get a feel of the GRE with a 55-question free test</p>

                      {data?.free_test?.status === "completed" ?
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21 10V19.5C21 20.3285 20.3285 21 19.5 21H4.5C3.67158 21 3 20.3285 3 19.5V4.5C3 3.67158 3.67158 3 4.5 3H15"
                              stroke={colors.primaryColor}
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M8 10L13 14L20.5 3.5"
                              stroke={colors.primaryColor}
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <p style={{ margin: 0, color: colors.primaryColor }}>
                            You’ve completed the free test, View your results below
                          </p>
                        </div>
                        :
                        <button
                          onClick={() => {
                            navigate(`/test`);
                            localStorage.setItem('_GRE_test_id', data?.free_test?.assigned_test_id)
                            //  navigate(`/test?test_id=${data?.free_test?.assigned_test_id}`);
                          }}
                          className="btn dark"
                          style={{ display: "flex", alignItems: "center", gap: "6px", background: colors.buttonBg }}
                        >
                          <span>{data?.free_test?.status === "in_progress" ? "Resume" : 'Start'} Free Quiz</span>
                        </button>
                      }
                    </div>
                    :
                    <div>
                      <p>Youdon’t have Free test upgrade your plan.</p>
                    </div>
                  }
                </div>


                <div className="card">
                  <h3>Practice Test</h3>
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    {Array.isArray(data?.paid_tests) && data?.paid_tests?.length > 0 ? (
                      (() => {

                        const allCompleted = data?.paid_tests.every(t => t.status === "completed");

                        if (allCompleted) {
                          // SHOW this when all tests are completed
                          return (
                            <div>
                              <p>
                                Get a feel for the GRE with our 55-question sample test
                              </p>

                              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                <div style={{ height: "24px" }}>
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M21 10V19.5C21 20.3285 20.3285 21 19.5 21H4.5C3.67158 21 3 20.3285 3 19.5V4.5C3 3.67158 3.67158 3 4.5 3H15"
                                      stroke={colors.primaryColor}
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M8 10L13 14L20.5 3.5"
                                      stroke={colors.primaryColor}
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                                <p style={{ margin: 0, color: colors.primaryColor }}>
                                  You have completed all the practice tests. Visit View Performance to see your test results.
                                </p>
                              </div>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <div style={{ height: "24px" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                  >
                                    <circle cx="12" cy="12" r="12" fill={colors.primaryColor} />
                                    <path d="M13 3L6 13h5v8l7-10h-5z" fill="#fff" />
                                  </svg>
                                </div>
                                <p style={{ margin: 0, color: colors.primaryColor }}>
                                  Upgrade your plan to unlock more tests.
                                </p>
                              </div>
                            </div>
                          );
                        }

                        // find next not completed test
                        const nextTest = data.paid_tests.find(t => t.status !== "completed");

                        // if all are completed, fallback to the last one
                        const targetTest =
                          nextTest || data.paid_tests[data.paid_tests.length - 1];

                        // find index (safely)
                        const currentIndex =
                          data.paid_tests.findIndex(
                            t => t.assigned_test_id === targetTest?.assigned_test_id
                          ) + 1;

                        const totalTests = data.paid_tests.length;

                        // Button label logic
                        const buttonLabel =
                          targetTest?.status === "in_progress"
                            ? `Resume Test ${currentIndex}/${totalTests}`
                            : `Start Test ${currentIndex}/${totalTests}`;

                        return (
                          <div>
                            <p>
                              Get a feel for the GRE with our 55-question sample test
                            </p>
                            <button
                              className="btn gray"
                              onClick={() => {
                                if (targetTest) {
                                  navigate(`/test`);
                                  localStorage.setItem('_GRE_test_id', targetTest.assigned_test_id)
                                  // navigate(`/test?test_id=${targetTest.assigned_test_id}`);
                                }
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                backgroundColor: colors.buttonBg,
                              }}
                            >
                              <span style={{ fontWeight: "500" }}>
                                {buttonLabel}
                              </span>
                            </button>
                          </div>
                        );
                      })()
                    ) :
                      <div>
                        <p>
                          You don’t have any available practice tests. Please upgrade your plan for practice tests.
                        </p>
                        <button
                          className="btn dark"
                          onClick={() => { navigate('/pricing') }}
                        >
                          <span >Upgrade Plan</span>
                        </button>
                      </div>
                    }
                  </div>
                </div>

                <div className="card">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 11.5H11V12.5H7V11.5ZM5 11.5H6V12.5H5V11.5ZM7 9H11V10H7V9ZM5 9H6V10H5V9ZM7 6.5H11V7.5H7V6.5ZM5 6.5H6V7.5H5V6.5Z"
                        fill="black"
                      />
                      <path
                        d="M12.5 2.5H11V2C11 1.73478 10.8946 1.48043 10.7071 1.29289C10.5196 1.10536 10.2652 1 10 1H6C5.73478 1 5.48043 1.10536 5.29289 1.29289C5.10536 1.48043 5 1.73478 5 2V2.5H3.5C3.23478 2.5 2.98043 2.60536 2.79289 2.79289C2.60536 2.98043 2.5 3.23478 2.5 3.5V14C2.5 14.2652 2.60536 14.5196 2.79289 14.7071C2.98043 14.8946 3.23478 15 3.5 15H12.5C12.7652 15 13.0196 14.8946 13.2071 14.7071C13.3946 14.5196 13.5 14.2652 13.5 14V3.5C13.5 3.23478 13.3946 2.98043 13.2071 2.79289C13.0196 2.60536 12.7652 2.5 12.5 2.5ZM6 2H10V4H6V2ZM12.5 14H3.5V3.5H5V5H11V3.5H12.5V14Z"
                        fill="black"
                      />
                    </svg>
                    <h3 style={{ margin: "0" }}>View Performance</h3>
                  </div>

                  {data?.has_completed_test ?
                    <div>
                      <p>Review your performance on completed tests.</p>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <button
                          className="btn gray"
                          onClick={() => {
                            navigate('/result');
                            // localStorage.setItem("GRE_test_data", JSON.stringify(data))
                          }}
                          style={{ display: "flex", alignItems: "center", gap: "6px", backgroundColor: colors.buttonBg }}
                        >
                          <span>Go to Results</span>
                        </button>
                      </div>
                    </div>
                    :
                    <div>
                      <p>No data available. Take a test to view your performance</p>
                    </div>
                  }
                </div>

                <div className="card" style={{ background: colors.primaryColor, color: colors.textWhite }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <circle cx="12" cy="12" r="12" fill="white" />
                      <path d="M13 3L6 13h5v8l7-10h-5z" fill={colors.primaryColor} />
                    </svg>
                    <h3 style={{ margin: 0 }}>Upgrade Your Plan</h3>
                  </div>
                  <p style={{ color: colors.textWhite }}>
                    Unlock more tests and delatiled analytics.
                  </p>
                  <button
                    className="btn dark"
                    onClick={() => { navigate('/pricing') }}
                  >
                    <span >Upgrade Plan</span>
                  </button>
                </div>
              </div>

              {/* <div className="logout">
            <button className="btn gray">Logout Now</button>
          </div> */}
            </div>
          </div>
        </div>
      }
    </div >

  );
};

export default DashboardComponent;
